import { useTranslation } from 'react-i18next';
import '../locales/studentNetworkV2/studentNetworkV2-en.json';

type LoadMoreButtonProps = {
    hasMore: boolean;
    isFetching: boolean;
    remaining: number;
    onClick: () => void;
    error?: boolean;
    onRetry?: () => void;
};

export function LoadMoreButton({ hasMore, isFetching, remaining, onClick, error, onRetry }: LoadMoreButtonProps) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'studentNetworkV2.studentNetworkV2' });

    if (!hasMore && !error) return null;

    if (error) {
        return (
            <div className="mt-4 flex justify-center py-3">
                <button
                    type="button"
                    onClick={onRetry}
                    className="rounded-full border border-slate-grey-200 bg-slate-grey-100-alt px-6 py-2.5 text-sm font-medium text-black transition-colors hover:bg-slate-grey-100"
                >
                    {t('errors.loadMoreFailed')}
                </button>
            </div>
        );
    }

    return (
        <div className="mt-4 flex justify-center py-3">
            <button
                type="button"
                onClick={onClick}
                disabled={isFetching}
                className="rounded-full border border-slate-grey-200 bg-slate-grey-100-alt px-6 py-2.5 text-sm font-medium text-black transition-colors hover:bg-slate-grey-100"
            >
                {isFetching
                    ? t('people.loading')
                    : `${t('people.loadMore')} (${remaining.toLocaleString()} ${t('people.remaining')})`}
            </button>
        </div>
    );
}
